import React, {useContext, useEffect, useCallback} from "react";
import {useTranslation} from "react-i18next";
import { AppContext } from "../../context/AppContext";
import "./OrderConfirmationPage.css";
import axios from "axios";

const OrderConfirmationPage = () => {
    const {t} = useTranslation();
    const { confirmationResult, setConfirmationResult } = useContext(AppContext);

    const revokeUrl = useCallback(() => {
        if (confirmationResult && confirmationResult.pdfDownloadData) {
            URL.revokeObjectURL(confirmationResult.pdfDownloadData);
        }
    }, [confirmationResult]);

    useEffect(() => {
        return () => {
            revokeUrl();
        };
    }, [revokeUrl]);

    const downloadManually = async () => {
        if (!confirmationResult || !confirmationResult.pdfDownloadData) return;

        const fileName = "order-form.pdf";

        try {
            const blob = confirmationResult.pdfDownloadData;
            const objectUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(objectUrl);
        } catch (e) {
            const link = document.createElement("a");

        }
    };

    const hasPdf = Boolean(confirmationResult.pdfDownloadData);
    const emailFailed = Boolean(confirmationResult.emailFailed);
    const orderNumber = confirmationResult.orderNumber;

    const bodyKey =
        !confirmationResult.success
            ? emailFailed
                ? "page.confirmation.body.email-failure"
                : hasPdf
                    ? "page.confirmation.body.failure"
                    : "page.confirmation.body.failure-no-download"
            : "page.confirmation.body.success";

    const failureTitleKey = emailFailed
        ? "page.confirmation.title.email-failure"
        : "page.confirmation.title.failure";


    return (
        <div className="order-confirmation-page" role="status" aria-live="polite">
            {confirmationResult && confirmationResult.success && (
                <div className="confirmation-card confirmation-card--success">
                    <h1 className="confirmation-title">
                        {t("page.confirmation.title.success", { defaultValue: "Thank you for your order!" })}
                    </h1>
                    {orderNumber && (
                        <p className="confirmation-order-number">
                            {t("page.confirmation.label.orderNumber", { defaultValue: "Order number" })}: <strong>{orderNumber}</strong>
                        </p>
                    )}
                    <p className="confirmation-message">
                        {t("page.confirmation.body.success", { defaultValue: "We've emailed your order confirmation. Please check your inbox (and spam folder)." })}
                        <strong>{t("page.confirmation.footer.success", { defaultValue: "ASD Systems Team" })}</strong>
                    </p>
                    {hasPdf && (
                      <div className="btn-Wrapper">
                          <button className="btn-next" onClick={downloadManually}>
                              {t("global.btn.downloadPDF", { defaultValue: "Download PDF" })}
                          </button>
                      </div>
                    )}
                </div>
            )}
            {confirmationResult && confirmationResult.success === false && (
                <div className="confirmation-card confirmation-card--error">
                    <h1 className="confirmation-title">
                        {t(failureTitleKey, { defaultValue: "We're sorry — something went wrong." })}
                    </h1>
                    {orderNumber && (
                        <p className="confirmation-order-number">
                            {t("page.confirmation.label.orderNumber", { defaultValue: "Order number" })}: <strong>{orderNumber}</strong>
                        </p>
                    )}
                    <p className="confirmation-message">
                        {t(bodyKey)}
                    </p>

                    {hasPdf && (
                        <div className="btn-Wrapper">
                            <button className="btn-next" onClick={downloadManually}>
                                {t("global.btn.downloadPDF", { defaultValue: "Download PDF" })}
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
};

export default OrderConfirmationPage;